'use strict';

var fragt = fragt || {};
var novicell = novicell || {};

fragt.addBoxClass = fragt.addBoxClass || new function () {
    this.init = function () {
        var section = document.querySelectorAll('.icon-boxes .grid-column');
        
        for (var i = 0; i < section.length; i++) {
            var box = section[i];  
            
            var getArticle = box.querySelector('.icon-box');
            var getAnchor = box.querySelector('.icon-box__link');
            
            var getUrl = getAnchor.getAttribute('href');
            var lastSegment = getUrl.match(/([^\/]*)\/*$/)[1];

            // get elements inside a tag.
            var getBoxInner = box.querySelector('.icon-box__inner');
            var getBoxContent = box.querySelector('.icon-box__content');
            var getSvg = box.querySelector('.icon-box__icon');
            var getH3Tag = box.querySelector('.h3--icon-box');
            var getPTag = box.querySelector('.p--icon-box');
            var getLinkFake = box.querySelector('.link-fake');

            // Assign lastSegment as class with gtm prefix
            getArticle.classList.add('gtm_'+lastSegment);
            getAnchor.classList.add('gtm_'+lastSegment);
            getBoxInner.classList.add('gtm_'+lastSegment);
            getBoxContent.classList.add('gtm_'+lastSegment);
            getSvg.classList.add('gtm_'+lastSegment);
            getH3Tag.classList.add('gtm_'+lastSegment);
            getPTag.classList.add('gtm_'+lastSegment);
            getLinkFake.classList.add('gtm_'+lastSegment);
        }
    };
}();